import plus from '../../Images/Vector@2x.png'
import arrow from '../../Images/Vector (8).png'
const TabelData = [
    {
        id: 1,
        locality: "DLF",
        address: "Sector 2",
        area: "500Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "11",
            age: "4 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },
    {
        id: 2,
        locality: "DLF",
        address: "Sector 4 ",
        area: "600Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "15",
            age: "10 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },
    {
        id: 3,
        locality: "DLF",
        address: "Sector 2",
        area: "800Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Lorem",
            contact: "11",
            age: "4 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },


    {
        id: 4,
        locality: "DLF",
        address: "Sector 2",
        area: "500Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "11",
            age: "4 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },
    {
        id: 5,
        locality: "DLF",
        address: "Sector 4 ",
        area: "600Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "15",
            age: "10 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },
    {
        id: 6,
        locality: "DLF",
        address: "Sector 2",
        area: "500Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "11",
            age: "4 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },

    {
        id: 7,
        locality: "DLF",
        address: "Sector 2",
        area: "500Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "11",
            age: "4 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },
    {
        id: 8,
        locality: "DLF",
        address: "Sector 4 ",
        area: "600Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "15",
            age: "10 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },
    {
        id: 9,
        locality: "DLF",
        address: "Sector 2",
        area: "500Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "11",
            age: "4 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },
    {
        id: 10,
        locality: "DLF",
        address: "Sector 2",
        area: "500Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "11",
            age: "4 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },
    {
        id: 11,
        locality: "DLF",
        address: "Sector 2",
        area: "500Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "11",
            age: "4 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },
    {
        id: 12,
        locality: "DLF",
        address: "Sector 2",
        area: "500Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "11",
            age: "4 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },
    {
        id: 13,
        locality: "DLF",
        address: "Sector 2",
        area: "500Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "11",
            age: "4 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },
    {
        id: 14,
        locality: "DLF",
        address: "Sector 2",
        area: "500Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "11",
            age: "4 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },
    {
        id: 15,
        locality: "DLF",
        address: "Sector 2",
        area: "500Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "11",
            age: "4 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },
    {
        id: 16,
        locality: "DLF",
        address: "Sector 2",
        area: "500Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "11",
            age: "4 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },
    {
        id: 17,
        locality: "DLF",
        address: "Sector 2",
        area: "500Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "11",
            age: "4 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },
    {
        id: 18,
        locality: "DLF",
        address: "Sector 2",
        area: "500Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "11",
            age: "4 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },
    {
        id: 19,
        locality: "DLF",
        address: "Sector 2",
        area: "500Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "11",
            age: "4 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },
    {
        id: 20,
        locality: "DLF",
        address: "Sector 2",
        area: "500Y",
        flat: "Ground floor",
        bhk: 3,
        img: plus,
        arrow: arrow,
        details: {
            propertyType: "For Sale",
            bathroom: 2,
            ownerName: "Chauhan",
            contact: "11",
            age: "4 Years",
            price: "6 Lakhs",
            extra: "--",
        },
    },

]
export default TabelData;